import { render, staticRenderFns } from "./SuburbSearch.vue?vue&type=template&id=7d983488&scoped=true&"
import script from "./SuburbSearch.vue?vue&type=script&lang=js&"
export * from "./SuburbSearch.vue?vue&type=script&lang=js&"
import style0 from "./SuburbSearch.vue?vue&type=style&index=0&id=7d983488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d983488",
  null
  
)

export default component.exports